import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckboxField } from 'src/components/mui-overrides/Checkbox';

interface Props {
  disabled?: boolean;
}

export const MaturityDateOnlyExpectedTerminationRightCheckbox: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <CheckboxField
      label={t('dashboard.assets.addedit.investment.securitytype.fields.maturityDateOnlyExpectedTerminationRight')}
      fieldName="investmentDetails.maturityDateOnlyExpectedTerminationRight"
      disabled={disabled}
    />
  );
};
